var map = {
	"./new-center-en/Index.vue": [
		60810,
		874,
		4857,
		810
	],
	"./new-center-jp/Index.vue": [
		67485,
		874,
		4857,
		7485
	],
	"./new-center-kr/Index.vue": [
		68959,
		874,
		4857,
		8959
	],
	"./new-center/Index.vue": [
		29599,
		874,
		4857,
		9599
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 34218;
module.exports = webpackAsyncContext;